import { CalculationOutput } from "../types";
import { PeriodMode, fmtEUR, suffix } from "../utils/period";

export default function MobileKpiStrip({
  output,
  periodMode,
}: {
  output: CalculationOutput | null;
  periodMode: PeriodMode;
}) {
  if (!output) return null;

  const bruto = (output as any).brutoFacturado ?? 0;
  const caja = (output as any).cajaPreviaRenta ?? (output as any).netoFinalTrasRenta ?? 0;
  const irpfTotal = (output as any).irpfTotal ?? output.irpf?.cuotaTotal ?? 0;
  const netoFiscal = output.netoFiscalAnual ?? (output.rendimientoNeto ?? 0) - irpfTotal;

  const items = [
    { label: "Bruto (sin IVA)", value: bruto, tone: "#312e81" },
    { label: "Caja estimada", value: caja, tone: "#0f766e" },
    { label: "Neto fiscal estimado", value: netoFiscal, tone: "#7c3aed" },
  ];

  const fmt = (n: number) => `${fmtEUR(n, periodMode)}${suffix(periodMode)}`;

  return (
    <div className="mobile-only" style={{ marginBottom: "12px" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
          gap: "10px",
        }}
      >
        {items.map((item) => (
          <div
            key={item.label}
            style={{
              background: "#fff",
              border: "1px solid var(--border)",
              borderRadius: "14px",
              padding: "14px",
              boxShadow: "var(--shadow)",
            }}
          >
            <div style={{ fontSize: "11px", color: "var(--muted)", textTransform: "uppercase", letterSpacing: "0.04em" }}>
              {item.label}
            </div>
            <div style={{ fontSize: "24px", fontWeight: 800, color: item.tone, letterSpacing: "-0.02em", marginTop: "4px" }}>
              {fmt(item.value)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
